/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Arkadium/GameEngine/Scenes/Nodes/SpriteNode',['lodash', 'pixi', 'util/list', 'util/eventhandler', 'absolute'],
function (_, PIXI, List, EventHandler, Absolute) {

    var SpriteNode = function (texture) {
        this.initSpriteNode(texture);
    };

    SpriteNode.prototype.constructor = SpriteNode;
    SpriteNode.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

    SpriteNode.ObjectId = 0;

    SpriteNode.prototype.initSpriteNode = function (texture) {
        PIXI.DisplayObjectContainer.call(this, texture);

        this.Id = ++SpriteNode.ObjectId;

        this.PointDown = this.MouseDown = new EventHandler();
        this.PointUp = this.MouseUp = new EventHandler();
        this.mousedown = this.handlePointDown.bind(this);
        this.touchstart = this.handlePointDown.bind(this);
        this.mouseup = this.handlePointUp.bind(this);
        this.touchend = this.handlePointUp.bind(this);

        // fix an issue on iOS devices in desktop mode
        if (Absolute.Platform._isMac() && Absolute.Platform._isIOS()) {
            this.mousedown = null;
            this.mouseup = null;
        } 	

        this.TextureAlphaEnabled = false;

        this.layer = 0;
        this._layerWhileAnimating = 0;

        this.IsLoaded = false;

        if (texture) {
            this.sprite = PIXI.Sprite.fromFrame(texture);
            this.sprite.anchor.x = this.sprite.anchor.y = 0.5;
            this.addChild(this.sprite);
        }
    };

    SpriteNode.prototype.handlePointDown = function (event) {        
        this.PointDown.handleEvent(this, event);
        event.originalEvent.stopPropagation();
    };

    SpriteNode.prototype.handlePointUp = function (event) {
        this.PointUp.handleEvent(this, event);
        event.originalEvent.stopPropagation();
    };

    SpriteNode.prototype.Register = function (scene) {
        this.Scene = scene;
    };

    Object.defineProperty(SpriteNode.prototype, "Parent", {
        get: function () {
            return this.parent;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "InputEnabled", {
        get: function () {
            return this.interactive;
        },
        set: function (value) {
            this.interactive = value;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "Visible", {
        get: function () {
            return this.visible;
        },
        set: function (value) {
            this.visible = value;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "Layer", {
        get: function () {
            return this.layer;
        },
        set: function (value) {
            this.layer = value;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "LayerWhileAnimating", {
        get: function () {
            return this._layerWhileAnimating;
        },
        set: function (value) {
            this._layerWhileAnimating = value;
            /*if (this.parent) {
                this.parent.children.sort(function (a, b) {
                    return a._layerWhileAnimating - b._layerWhileAnimating;
                })
            }*/
        }
    });



    // TODO clone?
    Object.defineProperty(SpriteNode.prototype, "Position", {
        get: function () {
            return this.position;
        },
        set: function (value) {
            this.position.x = value.x;
            this.position.y = value.y;

        }
    });

    Object.defineProperty(SpriteNode.prototype, "X", {
        get: function () {
            return this.position.x;
        },
        set: function (value) {
            if (this.position.x != value) {
                this.position.x = value;
            }
        }
    });


    Object.defineProperty(SpriteNode.prototype, "Y", {
        get: function () {
            return this.position.y;
        },
        set: function (value) {
            if (this.position.y != value) {
                this.position.y = value;
            }
        }
    });


    Object.defineProperty(SpriteNode.prototype, "Scale", {
        get: function () {
            return this.scale;
        },
        set: function (value) {
            this.scale.x = value.x;
            this.scale.y = value.y;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "Rotation", {
        get: function () {
            return this.rotation;
        },
        set: function (value) {
            this.rotation = value;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "ScaleX", {
        get: function () {
            return this.scale.x;
        },
        set: function (value) {
            this.scale.x = value;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "ScaleY", {
        get: function () {
            return this.scale.y;
        },
        set: function (value) {
            this.scale.y = value;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "ScaleUniform", {
        set: function (value) {
            this.scale.x = this.scale.y = value;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "Width", {
        get: function () {
            return this.width;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "Height", {
        get: function () {
            return this.height;
        }
    });

    Object.defineProperty(SpriteNode.prototype, "Alpha", {
        get: function () {
            return this.alpha;
        },
        set: function (value) {
            this.alpha = value;
        }
    });


    SpriteNode.prototype.AddChild = function (child) {
        this.addChild(child);
    };

    SpriteNode.prototype.AddChildAt = function (child, index) {
        this.addChildAt(child, index);
    };

    SpriteNode.prototype.RemoveChild = function (child) {
        this.removeChild(child);
    };

    SpriteNode.prototype.SetTexture = function (texture) {
        if (texture) {
            if (!this.sprite) {
                this.sprite = PIXI.Sprite.fromFrame(texture);
                this.sprite.anchor.x = this.sprite.anchor.y = 0.5;
                this.addChild(this.sprite);
            }
            else {
                this.sprite.setTexture(PIXI.Texture.fromFrame(texture));
            }
            this.IsLoaded = true;
        }
    };

    // TODO - move to scenenode and inherit?
    SpriteNode.prototype.Init = function (callback) {
        if (typeof callback == 'function') {
            callback();
        }
    };

    SpriteNode.prototype.UpdateInternal = function (time) {

    };

    SpriteNode.prototype.Update = function (time, pileHeightHalf) {
        if (this.Updated) {
            this.Updated.handleEvent(this, time);
        }
        this.UpdateInternal(time, pileHeightHalf);
        if (this.children) {
            for (var i = 0; i < this.children.length; i++) {
                if (this.children[i].Update) {
                    this.children[i].Update(time, pileHeightHalf);
                }
            }
        }
    };

    SpriteNode.prototype.ToGlobal = function (point) {
        return this.toGlobal(point);
    };

    SpriteNode.prototype.SetPosition = function (point) {
        this.position.x = point.x;
        this.position.y = point.y;
    };

    SpriteNode.prototype.SetScale = function (point) {
        this.scale.x = point.x;
        this.scale.y = point.y;
    };

    SpriteNode.prototype.SetRotation = function (rot) {
        this.rotation = rot;
    };



    return SpriteNode;
});

